export default __webpack_public_path__ + "static/media/OpenDyslexic-Bold.1082cfdb.otf";